export enum Platform {
  DDP = 0,
  ASQ = 1,
}
